import Button from '../../generic/Button';
import { icons } from '../../generic/Icon';

import styles from '../Login.module.less';

export type UseDifferentAccountButtonProps = {
  onClick: () => void;
};

/**
 * Anchor-styled "back" control shared by every login step past identifier entry. Returns the user to the start of the
 * flow so they can sign in as someone else.
 */
const UseDifferentAccountButton = ({ onClick }: UseDifferentAccountButtonProps) => (
  <Button type="anchor" size="small" icon={icons.arrowLeft} className={styles.backLink} onClick={onClick}>
    Use a different account
  </Button>
);

export default UseDifferentAccountButton;
